export const storageNamespace = 'tm';

type StorageScope = 'global' | 'user' | 'session';

const sanitizeScopePart = (value: string): string => value.replace(/[^a-zA-Z0-9_-]/g, '_');

export const buildStorageKey = (
  scope: StorageScope,
  domain: string,
  name: string,
  userScopeId?: string,
): string => {
  if (scope === 'user') {
    const scopedId = sanitizeScopePart(userScopeId || 'anonymous');
    return `${storageNamespace}.user.${scopedId}.${domain}.${name}`;
  }
  return `${storageNamespace}.${scope}.${domain}.${name}`;
};

export const STORAGE_KEY_ALIASES = {
  // Legacy key aliases used for read-time migration into canonical `tm.<scope>.<domain>.<name>` keys.
  // TODO: [storage-migration-cleanup] Remove legacy aliases and fallback reads after migration window.
  reconnectLastActiveGameId: ['tm:lastActiveGameId'],
  reconnectPendingTargetGameId: ['tm:pendingTargetGameId'],
  trainingLocalGameSnapshot: ['localGameSnapshot'],
  chatRecentEmojis: ['turfmaster.chat.recentEmojis'],
  localeLocalStorage: ['locale'],
  localeCookie: ['tm_locale'],
  cookieConsent: ['cookieConsentGranted'],
} as const;

export const getReconnectLastActiveGameIdKey = (userScopeId?: string): string =>
  buildStorageKey('user', 'reconnect', 'lastActiveGameId', userScopeId);

export const getReconnectPendingTargetGameIdKey = (): string =>
  buildStorageKey('session', 'reconnect', 'pendingTargetGameId');

/** Session hint: debug snapshot spawn source for premium-gate bypass on reload. */
export const getDebugSpawnSourceKey = (userScopeId?: string): string =>
  buildStorageKey('session', 'debug', 'spawnSource', userScopeId);

export const getTrainingLocalGameSnapshotKey = (userScopeId?: string): string =>
  buildStorageKey('user', 'training', 'localGameSnapshot', userScopeId);

export const getChatRecentEmojisKey = (userScopeId?: string): string =>
  buildStorageKey('user', 'chat', 'recentEmojis', userScopeId);

export const localeLocalStorageKey = buildStorageKey('global', 'i18n', 'locale');
export const localeCookieName = buildStorageKey('global', 'i18n', 'locale');
export const cookieConsentName = buildStorageKey('global', 'cookies', 'consent');
